<h1 mat-dialog-title>Estás a punto de enviar las respuestas</h1>
<div mat-dialog-content>Al dar clic en Aceptar, tus respuestas serán enviadas con el fin de generar una
    calificación.</div>
<div mat-dialog-content>¿Estás seguro que deseas continuar?</div>
<div mat-dialog-actions>
    <button mat-button mat-dialog-close style="background-color: rgba(0, 191, 255, 0.869);">Cerrar</button>
    <button mat-button style="background-color: rgba(255, 82, 82, 0.655);" (click)="sendAnswers()">Aceptar</button>
</div>